// extracted by mini-css-extract-plugin
module.exports = {"section":"MediaDetailsDescriptionList_section__GVxd0","title":"MediaDetailsDescriptionList_title__f0LCk","content":"MediaDetailsDescriptionList_content__N6uoZ"};